import React from 'react';
import FinancialReportPage from './FinancialReportPage';

const MobileFinancialReportPage: React.FC = () => <FinancialReportPage category="mobile" />;

export default MobileFinancialReportPage;
